// English strings of the phone-menu guide. The Dutch dictionary is typed
// against these keys, so a missing translation fails the typecheck.
export const en = {
  // navigation / chrome
  start: 'Home',
  callflow: 'Call flow',
  departments: 'Departments',
  people: 'Employees',
  hours: 'Opening hours',
  structure: 'Full structure',
  about: 'About this overview',
  navigation: 'Navigation',
  section: 'Section',
  search: 'Search department or employee',
  noResults: 'No results',
  resultMenu: 'Menu',
  resultDepartment: 'Department',
  resultPerson: 'Employee',
  language: 'Language',
  print: 'Print',
  edit: 'Edit',
  diagram: 'Diagram',
  guide: 'Guide',
  outline: 'Outline',
  openInBrowser: 'Open in browser',
  openInTeams: 'Open in Teams',
  location: 'Location',
  mainNumber: 'Main number',
  scopeText: 'Overview of the phone menu behind the main number.',
  snapshot: 'Snapshot',
  lastUpdated: 'Last updated',
  syncedFromTeams: 'Synced from Teams',
  importedFromTeams: 'Imported from Teams',
  unknown: 'Unknown',
  yes: 'Yes',
  no: 'No',
  seconds: 'seconds',
  minutes: 'minutes',
  calls: 'calls',
  // status
  openNow: 'The main number is open now',
  closedNow: 'The main number is closed now',
  statusUnknown: 'Opening status unknown — hours not set',
  availableNow: 'Available now',
  notAvailableNow: 'Not available now',
  hoursUnknown: 'Hours unknown',
  nextChange: 'Next change',
  opensAt: 'opens',
  closesAt: 'closes',
  timeZone: 'Times in {tz}',
  today: 'today',
  tomorrow: 'tomorrow',
  // start
  heroTitle: 'Find the right department quickly',
  heroSubtitle: 'Follow the phone menu step by step',
  heroText: 'Choose the same keys a caller hears. Every step shows who answers, when the department is reachable and what a caller hears.',
  statsMenus: 'Menus',
  statsDepartments: 'Departments',
  statsAgents: 'Configured employees',
  statsGroups: 'Groups',
  quickTitle: 'Go directly to a department',
  quickIntro: 'Open a department to view the dialling route, employees and queue settings.',
  howTitle: 'How to use this overview',
  how1: 'Start at the main number.',
  how2: 'Choose the same language and menu key as during a real call.',
  how3: 'Open the destination to see who receives the call and what happens when nobody answers.',
  startCallflow: 'Start the call flow',
  // simulator
  callflowTitle: 'Interactive call flow',
  callflowIntro: 'Use the buttons or the number keys 0 to 9 on your keyboard.',
  restart: 'Start again',
  back: 'One step back',
  chooseOption: 'Choose an option',
  noOptions: 'This menu has no options.',
  menuChoice: 'Menu choice',
  autoAttendant: 'Phone menu',
  callQueue: 'Department',
  terminal: 'End point',
  thenRoutesTo: 'Then routes to',
  operator: 'Operator',
  afterHours: 'Outside these hours',
  afterHoursDisconnect: 'The call is disconnected.',
  afterHoursRoutes: 'The call goes to',
  parentHours: 'Parent menus determine the final availability.',
  businessHours: 'Availability',
  ownHours: 'Configured hours',
  effectiveHours: 'Effective hours through the main number',
  inherited: 'Follows the main number',
  prompt: 'What a caller hears',
  greeting: 'Greeting',
  menuPrompt: 'Menu prompt',
  weekday: 'Day',
  period: 'Hours',
  closed: 'Closed',
  always: 'All day',
  holidays: 'Holidays and closures',
  noHolidays: 'No holidays configured',
  // departments / queue detail
  departmentTitle: 'Departments',
  departmentIntro: 'All destinations reachable from the main number.',
  all: 'All',
  withAgents: 'With employees',
  withoutAgents: 'Without employees',
  filterHere: 'Filter this page',
  viewDepartment: 'View department',
  routes: 'Dialling routes',
  route: 'Route',
  routeHours: 'Availability through this route',
  copyRoute: 'Copy route',
  copied: 'Copied',
  noRoute: 'Not reachable through the menu',
  queueTeam: 'Employees in this department',
  noAgents: 'No employees are linked to this department.',
  agentsCount: 'employees',
  agentsOf: '{available} of {total} available',
  optedOut: 'opted out',
  call: 'Call',
  callDepartment: 'Call this department',
  email: 'Email',
  handling: 'Call handling',
  distribution: 'Distribution',
  presence: 'Use presence status',
  ringTime: 'Alert time per employee',
  optOut: 'Employees may opt out',
  conferenceMode: 'Conference mode',
  queueLanguage: 'Language',
  overflow: 'Queue full',
  timeout: 'Maximum waiting time',
  noAgent: 'No employees available',
  limit: 'Limit',
  appliesTo: 'Applies to',
  allCalls: 'All calls',
  newCalls: 'New calls',
  after: 'Then',
  sharedVoicemail: 'Shared voicemail',
  disconnect: 'Disconnect',
  forwardTo: 'Redirect to',
  voicemail: 'Voicemail',
  keepInQueue: 'Caller stays in the queue',
  transcription: 'Transcription',
  playedMessage: 'Message played',
  music: 'Music on hold',
  defaultMusic: 'Default music on hold',
  customMusic: 'Custom music',
  welcomeGreeting: 'Welcome greeting',
  callback: 'Callback',
  callbackKey: 'Key',
  offerAfter: 'Offered after',
  offerWhenWaiting: 'or when {n} calls are waiting',
  serviceLevel: 'Service level target',
  noCallback: 'No callback offered',
  voicemailGroups: 'Voicemail and callback',
  group: 'Group',
  members: 'Recipients',
  loadingMembers: 'Loading members…',
  membersFailed: 'Could not load members',
  noMembers: 'No members',
  // people
  peopleTitle: 'Employees by department',
  peopleIntro: 'These are the employees configured on each department in Teams.',
  person: 'Employee',
  department: 'Department',
  active: 'Takes calls',
  noPeople: 'No employees found for this filter.',
  // hours
  hoursTitle: 'Opening hours of the menus',
  hoursIntro: 'A department is reachable only when every menu on the chosen route is open.',
  // structure
  structureTitle: 'Full call flow',
  structureIntro: 'Click an item to open the interactive path or the department details.',
  // about
  aboutTitle: 'About this overview',
  aboutText: 'This overview is generated from the Microsoft Teams voice configuration. Structure and settings come from the last export or sync; opening status and availability are computed live.',
  source: 'Source',
  exportTaken: 'Teams export taken',
  autoSync: 'Automatic sync',
  manualImport: 'Manual import',
  documentedBy: 'Maintained by',
  // routing methods
  simultaneous: 'Simultaneously to all employees',
  serial: 'One by one in the configured order',
  roundRobin: 'Round robin',
  longestIdle: 'Longest idle employee first',
  // presence
  presenceAvailable: 'Available',
  presenceBusy: 'Busy',
  presenceAway: 'Away',
  presenceOffline: 'Offline',
  presenceDnd: 'Do not disturb',
  presenceInCall: 'In a call',
  presenceInMeeting: 'In a meeting',
  presenceUnknown: 'Presence unknown',
  presenceNotEnabled: 'Live availability is not enabled for this tenant. Ask your admin to grant the Presence.Read.All permission.',
  presenceGrant: 'Grant permission (admin)',
  presenceUnavailable: 'Live availability is temporarily unavailable.',
  // audio
  audioListen: 'Listen',
  audioStop: 'Stop',
  audioNotUploaded: 'Recording not uploaded yet',
  audioFile: 'Audio file',
  ttsListen: 'Listen (browser voice)',
  ttsUnavailable: 'Speech is not available in this browser',
  textToSpeech: 'Text to speech',
  // days
  monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday', thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
  mon: 'Mo', tue: 'Tu', wed: 'We', thu: 'Th', fri: 'Fr', sat: 'Sa', sun: 'Su',
  // misc
  langNl: 'Nederlands',
  langEn: 'English',
  footer: 'Phone menu',
  noLocations: 'No phone menus shared with you',
  selectLocation: 'Choose a location',
} as const;

export type I18nKey = keyof typeof en;
